import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PublicIcon from '@mui/icons-material/Public';
import PfIcon from '../assets/icons/PfIcon';

function CarloHome() {
    return (
        <Container className='container'>
            <Box className='bitoBg'>
            </Box>
            <Box className='floatit'>
                <p className='contentW personalContent'>
                    <h3> Rim "Bam" Bito <Link className='linkPop' to='../about-people-arena'><PfIcon /></Link></h3>
                    <br />
                    <a href='https://www.facebook.com/lucastle69' rel="noreferrer" target='_blank' className='noDeco'>
                        <FacebookIcon />    Facebook
                    </a>
                    <br />
                    <a href='https://www.instagram.com/lionesus/' rel="noreferrer" target='_blank' className='noDeco'>
                        <InstagramIcon />   Instagram
                    </a>
                    <br />
                    <a href='https://www.youtube.com/@lucastle69' rel="noreferrer" target='_blank' className='noDeco'>
                        <YouTubeIcon />    YouTube
                    </a>
                    <br />
                    <a href='https://pomoroad.com/' rel="noreferrer" target='_blank' className='noDeco'>
                        <PublicIcon />      Website
                    </a>
                    <br />
                </p>
            </Box>

        </Container>
    )
}

export default CarloHome;
